import React from "react";
//import L from "../util/L10n";
import useResizeObserver from '@react-hook/resize-observer'
import DangerouslySetHtmlContent from '../../util/DangerouslySetHtmlContent'

function useSize(target) {
    const [size, setSize] = React.useState();

    React.useLayoutEffect(() => {
        target && setSize(target.getBoundingClientRect());
    }, [target]);

    // Where the magic happens
    useResizeObserver(target, (entry) => setSize(entry.contentRect));
    return size;
}


export default function ExternalContent({
                                            extType, display
                                            /*classes,
                                            userLang,*/

                                        }) {

    const [target, setTarget] = React.useState();

    if(window.navigator.userAgent.indexOf("Prerender") >= 0) {
        return <div></div>;
    }


    let myStyle = {

        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
    };

    let html = "<div>Hallo " + extType + "</div>";

    let dpaEM24LiveCenter = `
        <div id="dpaEM24LiveCenter_2" style="overflow: hidden">
        <div id="dpaEM24LiveCenter">       
        <div 
           data-app='dpa-sportslive' 
            data-embed-type='iframe-dyn' 
            data-competition-id='fb_mem'
            data-language='de' 
            data-standalone='livecenter' 
            data-customer='nicht-zugeordnet' 
            data-mobile='false'
            data-src="https://embed.dpa-sportslive.com/customers/european-championchip/aws/men/2024/dpa-shop/html/index.html" 
            data-path='https://embed.dpa-sportslive.com/fb_mem/'>
        </div>
        </div>
        </div>
        <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaEM24LiveCenter = dpaEM24LiveCenter + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaEM24LiveCenter').offsetHeight;
            document.getElementById('dpaEM24LiveCenter_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaEM24LiveCenter'))
        </script>  
        `;
    }

    let dpaEM24Ergebnisse = `
        <div id="dpaEM24Ergebnisse_2" style="overflow: hidden">
        <div id="dpaEM24Ergebnisse">
        <div 
            data-app='dpa-sportslive' 
            data-embed-type='iframe-dyn' 
            data-competition-id='fb_mem' 
            data-language='de' 
            data-standalone='conference' 
            data-alignment='horizontal' 
            data-widget-header='false' 
            data-customer='nicht-zugeordnet' 
            data-mobile='false'
            data-src=https://embed.dpa-sportslive.com/customers/european-championchip/aws/men/2024/dpa-shop/html/index.html 
            data-path='https://embed.dpa-sportslive.com/fb_mem/'>
        </div>
        </div>
        </div>
        <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaEM24Ergebnisse = dpaEM24Ergebnisse + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaEM24Ergebnisse').offsetHeight;
            document.getElementById('dpaEM24Ergebnisse_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaEM24Ergebnisse'))
        </script>  
        `;
    }

    let dpaEM24Spielplan = `
        <div id="dpaEM24Spielplan_2" style="overflow: hidden">
        <div id="dpaEM24Spielplan">
        <div 
        data-app='dpa-sportslive' 
        data-embed-type='iframe-dyn' 
        data-competition-id='fb_mem'
        data-language='de' 
        data-standalone='schedule' 
        data-widget-header='false' 
        data-mobile='false'
        data-customer='nicht-zugeordnet' 
        data-src="https://embed.dpa-sportslive.com/customers/european-championchip/aws/men/2024/dpa-shop/html/index.html"
        data-path='https://embed.dpa-sportslive.com/fb_mem/'>
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>  
    
    `;


    if (display) {
        dpaEM24Spielplan = dpaEM24Spielplan + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaEM24Spielplan').offsetHeight;
            document.getElementById('dpaEM24Spielplan_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaEM24Spielplan'))
        </script>  
        `;
    }


    // Start Olympia24
    let dpaOlympia24LiveCenter = `
    <div id="dpaOlympia24LiveCenter_2" style="overflow: hidden">
    <div id="dpaOlympia24LiveCenter">
    <div 
    data-app='dpa-sportslive' 
    data-embed-type='iframe-dyn' 
    data-competition-id='oly_so'
    data-language='de' 
    data-standalone='livecenter' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet' 
    data-src="https://embed.dpa-sportslive.com/customers/olympics/aws/2024/dpa-shop/html/index.html" 
    data-path='https://embed.dpa-sportslive.com/oly_so/'>
    </div>   
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaOlympia24LiveCenter = dpaOlympia24LiveCenter + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaOlympia24LiveCenter').offsetHeight;
            document.getElementById('dpaOlympia24LiveCenter_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaOlympia24LiveCenter'))
        </script>  
        `;
    }
    //--
    let dpaOlympia24Medaillenspiegel = `
    <div id="dpaOlympia24Medaillenspiegel_2" style="overflow: hidden">
    <div id="dpaOlympia24Medaillenspiegel">
    <div 
    data-app='dpa-sportslive' 
    data-embed-type='iframe-dyn' 
    data-competition-id='oly_so'
    data-language='de' 
    data-standalone='medalsTable' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet' 
    data-src="https://embed.dpa-sportslive.com/customers/olympics/aws/2024/dpa-shop/html/index.html" 
    data-path='https://embed.dpa-sportslive.com/oly_so/'>
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaOlympia24Medaillenspiegel = dpaOlympia24Medaillenspiegel + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaOlympia24Medaillenspiegel').offsetHeight;
            document.getElementById('dpaOlympia24Medaillenspiegel_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaOlympia24Medaillenspiegel'))
        </script>  
        `;
    }
    //--
    let dpaOlympia24Bildergalerie = `
    <div id="dpaOlympia24Bildergalerie_2" style="overflow: hidden">
    <div id="dpaOlympia24Bildergalerie">
    <div 
    data-app='dpa-sportslive' 
    data-embed-type='iframe-dyn' 
    data-competition-id='oly_so'
    data-language='de' 
    data-standalone='gallery' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet' 
    data-src="https://embed.dpa-sportslive.com/customers/olympics/aws/2024/dpa-shop/html/index.html" 
    data-path='https://embed.dpa-sportslive.com/oly_so/'>
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaOlympia24Bildergalerie = dpaOlympia24Bildergalerie + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaOlympia24Bildergalerie').offsetHeight;
            document.getElementById('dpaOlympia24Bildergalerie_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaOlympia24Bildergalerie'))
        </script>  
        `;
    }

    // End Olympia24

    // Start EM25

    let dpaEM25FussballFrauenLiveCenter = `
        <div id="dpaEM25FussballFrauenLiveCenter_2" style="overflow: hidden">
        <div id="dpaEM25FussballFrauenLiveCenter">       
        <div 
           data-app='dpa-sportslive' 
            data-embed-type='iframe-dyn' 
            data-competition-id='fb_fem'
            data-language='de' 
            data-standalone='livecenter' 
            data-customer='nicht-zugeordnet' 
            data-mobile='false'
            data-src='https://embed.dpa-sportslive.com/customers/european-championship/aws/women/2025/dpa-shop/html/index.html' 
            data-path='https://embed.dpa-sportslive.com/fb_fem/'>
        </div>
        </div>
        </div>
        <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaEM25FussballFrauenLiveCenter = dpaEM25FussballFrauenLiveCenter + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaEM25FussballFrauenLiveCenter').offsetHeight;
            document.getElementById('dpaEM25FussballFrauenLiveCenter_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaEM25FussballFrauenLiveCenter'))
        </script>  
        `;
    }

    let dpaEM25FussballFrauenErgebnisse = `
        <div id="dpaEM25FussballFrauenErgebnisse_2" style="overflow: hidden">
        <div id="dpaEM25FussballFrauenErgebnisse">
        <div 
            data-app='dpa-sportslive' 
            data-embed-type='iframe-dyn' 
            data-competition-id='fb_fem' 
            data-language='de' 
            data-standalone='conference' 
            data-alignment='horizontal' 
            data-widget-header='false' 
            data-customer='nicht-zugeordnet' 
            data-mobile='false'
            data-src='https://embed.dpa-sportslive.com/customers/european-championship/aws/women/2025/dpa-shop/html/index.html' 
            data-path='https://embed.dpa-sportslive.com/fb_fem/'>
        </div>
        </div>
        </div>
        <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaEM25FussballFrauenErgebnisse = dpaEM25FussballFrauenErgebnisse + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaEM25FussballFrauenErgebnisse').offsetHeight;
            document.getElementById('dpaEM25FussballFrauenErgebnisse_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaEM25FussballFrauenErgebnisse'))
        </script>  
        `;
    }

    let dpaEM25FussballFrauenSpielplan = `
        <div id="dpaEM25FussballFrauenSpielplan_2" style="overflow: hidden">
        <div id="dpaEM25FussballFrauenSpielplan">
        <div 
        data-app='dpa-sportslive' 
        data-embed-type='iframe-dyn' 
        data-competition-id='fb_fem'
        data-language='de' 
        data-standalone='schedule' 
        data-widget-header='false' 
        data-mobile='false'
        data-customer='nicht-zugeordnet' 
        data-src="https://embed.dpa-sportslive.com/customers/european-championship/aws/women/2025/dpa-shop/html/index.html"
        data-path='https://embed.dpa-sportslive.com/fb_fem/'>
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>  
    `;

    if (display) {
        dpaEM25FussballFrauenSpielplan = dpaEM25FussballFrauenSpielplan + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaEM25FussballFrauenSpielplan').offsetHeight;
            document.getElementById('dpaEM25FussballFrauenSpielplan_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaEM25FussballFrauenSpielplan'))
        </script>  
        `;
    }


    // End EM25

    // Winter Olympia 26
    let dpaWinterOlympia26LiveCenter = `
    <div id="dpaWinterOlympia26LiveCenter_2" style="overflow: hidden">
    <div id="dpaWinterOlympia26LiveCenter">
    <div 
    data-app='dpa-sportslive-extra' 
    data-embed-type='iframe-dyn'
    data-competition-id='mailand-2026' 
    data-language='de' 
    data-standalone='livecenter' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet' 
    data-src="https://external.dpa-sportslive.com/de/livecenter/olympia/mailand-2026/liveticker"
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaWinterOlympia26LiveCenter = dpaWinterOlympia26LiveCenter + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaWinterOlympia26LiveCenter').offsetHeight;
            document.getElementById('dpaWinterOlympia26LiveCenter_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaWinterOlympia26LiveCenter'))
        </script>  
        `;
    }
    //--
    let dpaWinterOlympia26Medaillenspiegel = `
    <div id="dpaWinterOlympia26Medaillenspiegel_2" style="overflow: hidden">
    <div id="dpaWinterOlympia26Medaillenspiegel">
    <div 
    data-app='dpa-sportslive-extra' 
    data-embed-type='iframe-dyn' 
    data-competition-id='mailand-2026'
    data-language='de' 
    data-standalone='medaillenspiegel' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet'
    data-src='https://external.dpa-sportslive.com/de/livecenter/iframe/mailand-2026/medaillenspiegel/' 
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaWinterOlympia26Medaillenspiegel = dpaWinterOlympia26Medaillenspiegel + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaWinterOlympia26Medaillenspiegel').offsetHeight;
            document.getElementById('dpaWinterOlympia26Medaillenspiegel_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaWinterOlympia26Medaillenspiegel'))
        </script>  
        `;
    }
    //--
    let dpaWinterOlympia26Bildergalerie = `
    <div id="dpaWinterOlympia26Bildergalerie_2" style="overflow: hidden">
    <div id="dpaWinterOlympia26Bildergalerie">
    <div 
    data-app='dpa-sportslive-extra' 
    data-embed-type='iframe-dyn'
    data-competition-id='mailand-2026'
    data-language='de' 
    data-standalone='calendar-olympia' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet'  
    data-src='https://external.dpa-sportslive.com/de/livecenter/iframe/mailand-2026/calendar-olympia/' 
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaWinterOlympia26Bildergalerie = dpaWinterOlympia26Bildergalerie + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaWinterOlympia26Bildergalerie').offsetHeight;
            document.getElementById('dpaWinterOlympia26Bildergalerie_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaWinterOlympia26Bildergalerie'))
        </script>  
        `;
    }

    // End Winter Olympia 26




    // Fußball-WM 2026
    let dpaFussballWM26LiveCenter = `
    <div id="dpaFussballWM26LiveCenter_2" style="overflow: hidden">
    <div id="dpaFussballWM26LiveCenter">
    <div 
    data-app='dpa-sportslive' 
    data-embed-type='iframe-dyn'
    data-competition-id='fb_mwm'
    data-language='de' 
    data-standalone='liveCenter' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet' 
    data-live-center-view='fixtures'
    data-src="https://embed.dpa-sportslive.com/fb/liveCenter.html?colorMode=light"
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaFussballWM26LiveCenter = dpaFussballWM26LiveCenter + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaFussballWM26LiveCenter').offsetHeight;
            document.getElementById('dpaFussballWM26LiveCenter_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaFussballWM26LiveCenter'))
        </script>  
        `;
    }
    //--
    let dpaFussballWM26Spielplan = `
    <div id="dpaFussballWM26Spielplan_2" style="overflow: hidden">
    <div id="dpaFussballWM26Spielplan">
    <div 
    data-app='dpa-sportslive' 
    data-embed-type='iframe-dyn' 
    data-competition-id='fb_mwm'
    data-language='de' 
    data-standalone='fixtures' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet'
    data-src='https://embed.dpa-sportslive.com/fb/fixtures.html?colorMode=light' 
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaFussballWM26Spielplan = dpaFussballWM26Spielplan + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaFussballWM26Spielplan').offsetHeight;
            document.getElementById('dpaFussballWM26Spielplan_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaFussballWM26Spielplan'))
        </script>  
        `;
    }
    //--
    let dpaFussballWM26Tabellen = `
    <div id="dpaFussballWM26Tabellen_2" style="overflow: hidden">
    <div id="dpaFussballWM26Tabellen">
    <div 
    data-app='dpa-sportslive' 
    data-embed-type='iframe-dyn'
    data-competition-id='fb_mwm'
    data-language='de' 
    data-standalone='standing' 
    data-country='GER' 
    data-mobile='false'
    data-customer='nicht-zugeordnet'  
    data-src='https://embed.dpa-sportslive.com/fb/standing.html?colorMode=light' 
' 
    </div>
    </div>
    </div>
    <script type='text/javascript' src='https://core.dpa-infocom.net/js/dpa.js'></script>
    `;
    if (display) {
        dpaFussballWM26Tabellen = dpaFussballWM26Tabellen + `
        <script>
        function _sizeChanged() {
            let h = document.getElementById('dpaFussballWM26Tabellen').offsetHeight;
            document.getElementById('dpaFussballWM26Tabellen_2').style.height = "" + h-6 + "px";
            
        }
        new ResizeObserver(_sizeChanged).observe(document.getElementById('dpaFussballWM26Tabellen'))
        </script>  
        `;
    }

    // End Fußball-WM 2026





    if (extType === 1) {
        html = dpaEM24LiveCenter;
    } else if (extType === 2) {
        html = dpaEM24Ergebnisse;
    } else if (extType === 3) {
        html = dpaEM24Spielplan;
    } else if (extType === 4) {
        html = dpaOlympia24LiveCenter;
    } else if (extType === 5) {
        html = dpaOlympia24Medaillenspiegel;
    } else if (extType === 6) {
        html = dpaOlympia24Bildergalerie;
    } else if (extType === 7) {
        html = dpaEM25FussballFrauenErgebnisse;
    } else if (extType === 8) {
        html = dpaEM25FussballFrauenSpielplan;
    } else if (extType === 9) {
        html = dpaEM25FussballFrauenLiveCenter;
    } else if (extType === 10) {
        html = dpaWinterOlympia26LiveCenter;
    } else if (extType === 11) {
        html = dpaWinterOlympia26Medaillenspiegel;
    } else if (extType === 12) {
        html = dpaWinterOlympia26Bildergalerie;
    } else if (extType === 13) {
        html = dpaFussballWM26LiveCenter;
    } else if (extType === 14) {
        html = dpaFussballWM26Spielplan;
    } else if (extType === 15) {
        html = dpaFussballWM26Tabellen;
    }
    return (
        <div key={"externalContent_"} ref={setTarget} style={myStyle}>
            <DangerouslySetHtmlContent html={html}/>
        </div>
    );
}
